import EasyTranslate from "src/easy-translate";
import { IsMobile } from "utils/device";

const translateVogue = function () {
  // 先进行翻译初始化
  const div = document.createElement("div");
  div.className = "et";

  window.et_translate = new EasyTranslate({
    logVersion: false,
    enableMerge: false,
    excluded_blocks: [
      ".et-select",
      ".et-select-mobile",
      ".selectpricewrap",
      ".coupon-popover-content .count-down-content",
      "[class^=upSelling-custom-options-global-timeout]",
      //不翻译结账按钮
      ".inlineCart .check-button-group", // 结账按钮
      "[v-cloak]",
      ".checkoutrightbody .shoppingcarlist .price",
      ".checkoutrightbody .computedlist",
      ".checkoutrightbody .computetotal",
      ".checkoutrightbody .computetotalTip span"
    ],
    extra_definitions: [
      {
        type: 13,
        selector: "[data-title]",
        attribute: "data-title",
      },
      {
        type: 14,
        selector: "[data-description]",
        attribute: "data-description",
      },
    ],
    mount: div,
    mobileWidth: 768,
  });

  // 根据页面或者节点，判断是否挂载语言选择器
  const rightSearchBox = document.querySelector(".header-right.search-box");
  const isOrderPage = new RegExp(/\/order?-\w+|orders\/\d+/).test(
    location.pathname
  );

  if (isOrderPage) {
    return;
  }

  if (!IsMobile) {
    // pc
    if (!rightSearchBox) {
      return;
    }

    const searchBox = rightSearchBox as HTMLElement;
    // NOTE: change the SaaS self css, maybe some problem
    // get width
    const width = searchBox.clientWidth;

    // change style
    searchBox.setAttribute(
      "style",
      searchBox.getAttribute("style") + `width: ${width + 150}px;`
    );

    const search = rightSearchBox.querySelector(".search");
    const account = rightSearchBox.querySelector(".account");
    const cart = rightSearchBox.querySelector(".cart");

    const mountPoint = search || account || cart;

    if (mountPoint) {
      rightSearchBox.insertBefore(div, mountPoint);
    } else {
      rightSearchBox.appendChild(div);
    }
  } else {
    // mobile
    const mountPoint = document.querySelector(".lang_currency");

    const li = document.createElement("li");
    li.append(div);

    if (mountPoint) {
      mountPoint.after(li);
    }
  }
};

export { translateVogue };
